import type { PermissionCheckItem } from './type';
import { useUserStore } from '@stores/user';
import { getPermissionCheck } from '@/services/permission';

/**
 * 更新用户权益列表
 * @param projectId 项目 ID
 * @returns 权益列表数组,失败时返回 null
 */
export async function updateUserPermissionList(
  projectId: string,
): Promise<PermissionCheckItem[] | null> {
  if (!projectId) {
    return null;
  }

  const { setUserPermissionList } = useUserStore.getState();

  try {
    const res = await getPermissionCheck(projectId);

    if (res.data?.permissionCheckList) {
      setUserPermissionList(res.data.permissionCheckList);
      return res.data.permissionCheckList;
    }

    return null;
  } catch {
    return null;
  }
}
